var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "6px",
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_caret_up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Desktop---Contact-Details-(List)",
    transform: "translate(-253.000000, -254.000000)",
    fill: "#2A3D4C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(154.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.6085881,9.3436055 L102.745511,5.73822656 C103.108028,5.3215731 103.73967,5.27768655 104.156324,5.64020322 C104.191226,5.67057084 104.223979,5.70332397 104.254347,5.73822656 L107.39127,9.3436055 C107.753787,9.76025897 107.709901,10.3919012 107.293247,10.7544178 C107.111237,10.9127789 106.878112,11 106.636853,11 L100.363006,11 C99.8107212,11 99.3630059,10.5522847 99.3630059,10 C99.3630059,9.75874101 99.450227,9.52561559 99.6085881,9.3436055 Z",
    id: "icon_caret_up",
    transform: "translate(103.500000, 8.500000) rotate(-360.000000) translate(-103.500000, -8.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretUp);
export default __webpack_public_path__ + "static/media/icon_caret_up.c066262fdb1b77680a153d3975c8db41.svg";
export { ForwardRef as ReactComponent };